var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaffSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.589,
    height: 41.591,
    viewBox: "0 0 41.589 41.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-person",
    "data-name": "Icon ionic-ios-person",
    d: "M46.069,45.041c-.78-3.444-5.231-5.123-6.769-5.665a50.471,50.471,0,0,0-5.643-1.083,5.733,5.733,0,0,1-2.61-1.2c-.433-.52-.173-5.34-.173-5.34a16.065,16.065,0,0,0,1.235-2.35,30.316,30.316,0,0,0,.91-4.1s.888,0,1.2-1.56c.336-1.7.866-2.361.8-3.628-.065-1.246-.747-1.213-.747-1.213a18.99,18.99,0,0,0,.737-5.556c.1-4.452-3.39-8.838-9.7-8.838-6.4,0-9.813,4.387-9.716,8.838a19.808,19.808,0,0,0,.726,5.556s-.682-.032-.747,1.213c-.065,1.267.466,1.928.8,3.628.3,1.56,1.2,1.56,1.2,1.56a30.316,30.316,0,0,0,.91,4.1,16.065,16.065,0,0,0,1.235,2.35s.26,4.82-.173,5.34a5.734,5.734,0,0,1-2.61,1.2,50.471,50.471,0,0,0-5.643,1.083c-1.538.542-5.99,2.22-6.769,5.665a.866.866,0,0,0,.856,1.051H45.225A.864.864,0,0,0,46.069,45.041Z",
    transform: "translate(-4.501 -4.5)",
    fill: "#afb0ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffSelection);
export default __webpack_public_path__ + "static/media/StaffSelection.002ae40d4e02c79ced34681877b983b6.svg";
export { ForwardRef as ReactComponent };